import { Component, OnInit } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';

import { DataService, HTTPService, HelperService } from 'app/services';
import { config, messages } from 'app/constants';
import { UpdateRecipientDialogComponent } from 'app/modules/app-components/update-recipient-dialog/update-recipient-dialog.component';
import { templateTypes } from 'app/constants/templates/template-type';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-email-receipt',
  templateUrl: './email-receipt.component.html',
  styleUrls: ['./email-receipt.component.scss'],
  providers: [DialogService],
})
export class EmailReceiptComponent implements OnInit {
  card: any = {
    reminders: {
      heading: 'Custom Reminders',
      content: 'Send the customer reminder on',
      switch: false,
    },
    receipt: {
      heading: 'Attach Receipt',
      content: '',
      switch: true,
    },
  };
  subject: string = '';
  content: string = '';
  customer: any = {};
  payment: any = {};
  company: any = {};
  data: any = {};
  estimate: any = {};
  url: string = '';
  isLoadingReceiptURL: boolean = false;
  isEmailSelected: boolean = false;
  isSMSSelected: boolean = false;
  recipients = {
    emails: [],
    phones: [],
  };
  timezones: any = {};
  recipientTooltip: string = '';
  contacts: any[] = [];
  localizationSubscription: Subscription;
  currentLang: string = 'en';
  companyLocalization: boolean = false;
  customerId: string;

  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private httpService: HTTPService,
    private dialogConfig: DynamicDialogConfig,
    private helperService: HelperService,
    private dialogService: DialogService,
    private dataService: DataService
  ) { }

  async ngOnInit() {
    const data = this.dialogConfig.data;
    if (data && data.payment && data.payment.customer) {
      this.data = data.estimate;
      this.payment = data.payment;
    }

    this.company = await this.getCompanyDetails();
    this.localizationSubscription = this.dataService.getCompanyLocalization().subscribe((value) => {
      this.companyLocalization = value
      if (this.localizationSubscription) this.localizationSubscription.unsubscribe();
    })
    if (this.data.estimateId) {
      this.getEstimatesById(this.data.estimateId);
      this.getReceiptTemplate();
    }

  }

  switchLanguage() {
    if (this.currentLang === "en") {
      this.currentLang = 'fr';
      this.getReceiptTemplate();
      this.httpService.updateCustomer({ _id: this.customerId, preferredLanguage: 'fr'.toUpperCase() }).then((res) => {
        this.helperService.showToaster('success', 'Language updated successfully');
      });
    } else {
      this.currentLang = 'en';
      this.getReceiptTemplate();
      this.httpService.updateCustomer({ _id: this.customerId, preferredLanguage: 'en'.toUpperCase() }).then((res) => {
        this.helperService.showToaster('success', 'Language updated successfully');
      });
    }
  }

  getEstimatesById(estimateId: string) {
    this.httpService.getEstimateById(estimateId).then(
      (estimate) => {
        this.customer = estimate.customer;
        this.data = estimate;
        this.data.customer = estimate.customer;
        this.estimate = estimate;
        if (this.companyLocalization) {
          this.httpService.getCustomerPreferredLanguage(estimate.customer.customerId._id).then((res: any) => {
            if (res && res.preferredLanguage) {
              this.currentLang = res.preferredLanguage.toLowerCase();
              this.customerId = estimate.customer.customerId._id;
              this.getReceiptTemplate();
            }
          });
        }

        if (estimate.customer && estimate.customer.customerId) {
          this.isEmailSelected = estimate.customer.customerId.contactOnEmail;
          this.isSMSSelected = estimate.customer.customerId.contactOnPhone;

          if (estimate.customer.customerId.contactId && estimate.customer.customerId.contactId.contactInfo && estimate.customer.customerId.contactId.contactInfo.length) {
            this.setRecipient(estimate.customer.customerId.contactId.contactInfo);
          }
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  getCompanyDetails() {
    const { companyId } = this.helperService.getCompany();
    return this.httpService.getCompanyDetails(companyId);
  }

  getFile() {
    this.isLoadingReceiptURL = true;

    this.httpService.getDocument(this.payment._id).then(
      (res: any[]) => {
        if (res && res.length && res.length > 0) {
          this.url = res[0].link;
        } else {
          this.url = this.payment.receiptLink;
        }
        window.open(this.url, '_blank');
        this.isLoadingReceiptURL = false;
      },
      (err) => {
        this.helperService.showToaster('error', err);
        this.isLoadingReceiptURL = false;
      }
    );
  }

  downloadReceipt() {
    if (!this.payment.isPdfUploaded) {
      window.open(this.payment.previewLink, '_blank');
    } else {
      this.getFile();
    }
  }

  getReceiptTemplate() {
    this.company = this.helperService.getCompany();
    this.httpService
      .getTemplatesByTypeLang(templateTypes.receipt, this.currentLang)
      .then((template: any) => {
        if (template) {
          const { isMultiLocationEnabled, companyId } = this.helperService.getCompany();
          this.httpService.getCompanyDetails(companyId, 'fetchTimezones=true').then(
            (company) => {
              this.timezones = company.timezones;
              const { _id, contents, subject, footer } = template;
              this.subject = subject;
              this.content = this.helperService.templateParser(
                contents,
                {
                  company: isMultiLocationEnabled ? company.shop : company,
                  customer: this.data.customer && this.data.customer,
                  vehicle: this.data.vehicle && this.data.vehicle.vehicleId,
                  payment: this.payment,
                  order: {
                    title: this.estimate.title,
                    code: this.estimate.code,
                    paid: this.estimate.card + this.estimate.cheque + this.estimate.cash + this.estimate.creditPayment + this.estimate.thirdParty,
                    authStatus: this.estimate.authorized ? 'approved' : 'not approved',
                    orderStatus: this.estimate.orderStatus,
                    total: this.estimate.total && this.estimate.total.grand,
                  },
                },
                false,
                this.timezones
              );
            },
            (err) => {
              this.helperService.showToaster('error', err);
            }
          );
        }
      })
      .catch((err) => {
        this.helperService.showToaster('error', err);
      });
  }

  closeDialog() {
    this.dynamicDialogRef.close();
  }

  onSubmit() {
    if (!this.isEmailSelected && !this.isSMSSelected) {
      this.helperService.showToaster('error', 'Please select Email or SMS.');
      return;
    }

    if (this.data.customer && this.data.customer.customerId) {
      const data = {
        recipients: [...this.recipients.emails, ...this.recipients.phones],
        subject: this.subject,
        contents: this.content,
        smsContents: this.content,
        isSMS: this.isSMSSelected,
        isEmail: this.isEmailSelected,
        manualReviewRequest: false,
        minRating: 0,
        reviewReminder: false,
        receiptAttach: true,
        reviewAttach: false,
        reminders: null,
        estimate: {
          estimateId: this.data._id,
          title: this.data.title,
          code: this.data.code,
          estimateBy: this.data.estimateBy,
          createdAt: this.data.createdAt,
        },
        customer: {
          customerId: this.data.customer.customerId._id ? this.data.customer.customerId._id : this.data.customer.customerId,
          fullName: this.data.customer.fullName,
          displayName: this.data.customer.displayName,
          email: this.data.customer.email,
          phone: this.data.customer.phone,
        },
        paymentId: this.payment._id ? this.payment._id : null,
      };

      if (!data.estimate.estimateId) {
        delete data.estimate;
      }

      this.httpService.sendReviewRequest(data).then(
        (res) => {
          this.closeDialog();
          this.helperService.showToaster('success', messages.receiptSent);
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      );
    } else {
      this.helperService.showToaster('error', messages.selectCustomer);
    }
  }

  toggleActiveState(type: string, status: boolean) {
    if (type === 'reminders') {
      this.card[type].switch = status;
    } else {
      this[type] = status;
    }

    if (['isEmailSelected', 'isSMSSelected'].includes(type)) {
      this.setRecipient(this.contacts, type);
    }
  }

  setRecipient(contacts: any[], type: string = '') {
    this.contacts = contacts;

    if (!this.isEmailSelected) {
      this.recipients.emails = [];
    }

    if (!this.isSMSSelected) {
      this.recipients.phones = [];
    }

    if (contacts && contacts.length) {
      contacts.forEach(({ _id, value, contactType, isPrimary }: any) => {
        if (isPrimary) {
          if (contactType === 'email' && this.isEmailSelected && ['', 'isEmailSelected'].includes(type)) {
            this.recipients.emails = [
              {
                type: 'email',
                value: value,
                recipientId: _id,
              },
            ];
          } else if (contactType === 'mobile' && this.isSMSSelected && ['', 'isSMSSelected'].includes(type)) {
            this.recipients.phones = [
              {
                type: 'mobile',
                value: value,
                recipientId: _id,
              },
            ];
          }
        }
      });
    }

    this.recipientTooltip = this.helperService.createContactTooltip(this.recipients, 'Confirmation');
  }

  openUpdateRecipientDialog(type: string) {
    const { customer } = this.estimate;

    if (!this.isSMSSelected && !this.isEmailSelected) return;
    if (!customer || (customer && !customer.customerId)) return;

    const recipients = [...this.recipients.emails.map(({ value }) => value), ...this.recipients.phones.map(({ value }) => value)];

    const ref = this.dialogService.open(UpdateRecipientDialogComponent, {
      closeOnEscape: false,
      width: '650px',
      styleClass: 'add-dialog add-receipt-modal update-contact-dialog',
      showHeader: false,
      data: {
        customerId: this.estimate.customer.customerId._id,
        recipients: this.helperService.deepCopy(recipients),
        contactOnPhone: this.isSMSSelected,
        contactOnEmail: this.isEmailSelected,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        const recipients = {
          emails: [],
          phones: [],
        };

        if (data.contacts && data.contacts && data.contacts.length) {
          for (let i = 0; i < data.contacts.length; i++) {
            const { _id, value, contactType, isChecked } = data.contacts[i];
            const contact = {
              value,
              recipientId: _id,
              type: contactType,
            };

            if (isChecked) {
              if (contactType === 'email') {
                recipients.emails.push(contact);
              } else {
                recipients.phones.push(contact);
              }
            }
          }
        }

        this.recipients = this.helperService.deepCopy(recipients);

        this.recipientTooltip = this.helperService.createContactTooltip(this.recipients, 'Recipient');
      }

      onClose.unsubscribe();
    });
  }
}
